module.exports = __webpack_public_path__ + "img/2.67274a22.png";